let handler;

// BrowserRouter and panel tab actions share the same confirmation surface.
export function registerNavigationConfirmation(nextHandler) {
  handler = nextHandler;
  return () => { if (handler === nextHandler) handler = undefined; };
}

export function requestNavigationConfirmation(message, callback) {
  if (handler) handler(message, callback);
  else callback(false); // Never discard a draft while the router is unavailable.
}

export function runGuardedDashboardNavigation(history, commit) {
  if (history.runGuarded) history.runGuarded(commit);
  else commit();
}
